export const temporarilySimplifiedLanguage = {
  headlineForBodies: (num: number, of: number) =>
    //No `of === 1` case (because tooComplex case would proceed this case)
    `${num} of ${of} bodies are temporarily simplified`,
  descriptionForBodies:
    //No `of === 1` case (because tooComplex case would proceed this case)
    'Hide other bodies or isolate a simplified body to view it in more detail.',

  headlineForPart: 'This part is temporarily simplified',
  descriptionForPart:
    'Hide other parts or isolate this part to view it in more detail.',

  headlineForBody: 'This body is temporarily simplified',
  descriptionForBody:
    'Hide other bodies or isolate a simplified body to view it in more detail.',

  helpUrl: 'https://help.paperlessparts.com/s/article/3D-viewing-limits',
};

export const tooComplexLanguage = {
  headlineForBodies: (num: number, of: number) =>
    of === 1
      ? 'Body is too complex to show in 3D'
      : `${num} of ${of} bodies are too complex to show in 3D`,
  descriptionForBodies: (of: number) =>
    of === 1
      ? 'This body can only be shown in simplified form.  This does not indicate a problem with the file.'
      : 'These bodies can only be shown in simplified form.  This does not indicate a problem with the file.',

  headlineForPart: 'This part is too complex to show in 3D',
  descriptionForPart:
    'This part can only be shown in simplified form. This does not indicate a problem with the file.',

  headlineForBody: 'This body is too complex to show in 3D',
  descriptionForBody:
    'This body can only be shown in simplified form. This does not indicate a problem with the file.',

  helpUrl: 'https://help.paperlessparts.com/s/article/3D-viewing-limits',
};

export const failedLanguage = {
  headlineForBodies: (num: number, of: number) =>
    of === 1
      ? 'Part failed processing'
      : `${num} of ${of} parts failed processing`,
  descriptionForBodies: (of: number) =>
    of === 1
      ? 'This part may have missing or invalid data.'
      : 'These parts may have missing or invalid data.',

  headlineForPart: "This part couldn't be processed",
  descriptionForPart: 'This part may have missing or invalid data.',

  helpUrl:
    'https://help.paperlessparts.com/s/article/CAD-assembly-file-processing',
};
